/**
 * Application Constants
 */

export const APP_NAME = 'ameboGPT';
export const APP_DESCRIPTION = 'Nigerian-accented Text-to-Speech API';
export const APP_URL = 'https://amebogpt.com.ng';

export const ROUTES = {
  HOME: '/',
  PRICING: '/pricing',
  DOCS: '/docs',
  DASHBOARD: '/dashboard',
  LOGIN: '/login',
  SIGNUP: '/signup',
  API_KEYS: '/dashboard/keys',
  USAGE: '/dashboard/usage',
  VOICE_ASSISTANT: '/dashboard/voice-assistant',
} as const;

export const PLAN_TIERS = {
  FREE: 'free',
  STARTER: 'starter',
  PROFESSIONAL: 'professional',
  BUSINESS: 'business',
  ENTERPRISE: 'enterprise',
} as const;

export const LANGUAGES = {
  ENGLISH: 'english',
  HAUSA: 'hausa',
  IGBO: 'igbo',
  YORUBA: 'yoruba',
} as const;

